export const workingEnv = process.env.REACT_APP_WORKING_ENVIRONMENT;

const AppConfig = {
    baseUrl: workingEnv === 'local' ? "https://svgheart.uforiaprojects.com" :  window.baseUrl,
    storageUrl: workingEnv === 'local' ? "https://svgheart.uforiaprojects.com/storage" :  window.storageUrl,
    googleApiKey: "AIzaSyCy4vw_j9BC78AUkTIan9N4zaMbnfXf9nM",
    wordpressUrl:'https://test2.svgheart.com//wp-json/svgheartwc/v1',

};
export default AppConfig;
